/* Webstra – globale CRO-/Mobile-Optimierungen (v1, 19.10.2026) */
(function () {
  'use strict';

  /* ---------- Sticky "In den Warenkorb"-Leiste ---------- */
  function initStickyAtc() {
    var bar = document.getElementById('wb-satc');
    if (!bar) return;
    var mainBtn = document.querySelector('#MainContent product-form button[name="add"]');
    if (!mainBtn) return;

    var barBtn = bar.querySelector('.wb-satc__btn');
    var priceEl = bar.querySelector('.wb-satc__price');
    var variantEl = bar.querySelector('.wb-satc__variant');
    var mainBtnVisible = true;

    document.body.classList.add('wb-satc-page');

    function readPrice() {
      var box = document.querySelector('#MainContent [id^="price-template"]') ||
        document.querySelector('#MainContent .price');
      if (!box) return null;
      var sale = box.querySelector('.price--on-sale .price-item--sale');
      var regular = box.querySelector('.price__regular .price-item--regular');
      var el = sale || regular;
      var txt = (el ? el.textContent : box.textContent) || '';
      txt = txt.replace(/\s+/g, ' ').trim();
      return txt || null;
    }

    function readVariant() {
      var picker = document.querySelector('#MainContent variant-selects, #MainContent variant-radios');
      if (!picker) return '';
      var parts = [];
      picker.querySelectorAll('fieldset').forEach(function (fs) {
        var legend = fs.querySelector('legend');
        var label = legend ? legend.textContent.replace(/\s+/g, ' ').trim() : '';
        if (label.indexOf(':') === -1) {
          var checked = fs.querySelector('input:checked');
          if (checked) label = (label ? label + ': ' : '') + checked.value;
        }
        if (label) parts.push(label);
      });
      picker.querySelectorAll('select').forEach(function (sel) {
        var wrap = sel.closest('.product-form__input');
        var lbl = wrap ? wrap.querySelector('label') : null;
        var name = lbl ? lbl.textContent.replace(/\s+/g, ' ').trim() : '';
        var opt = sel.options[sel.selectedIndex];
        if (opt) parts.push((name ? name + ': ' : '') + opt.textContent.trim());
      });
      return parts.join(' · ');
    }

    function sync() {
      var p = readPrice();
      if (p && priceEl) priceEl.textContent = p;
      if (variantEl) {
        var v = readVariant();
        variantEl.textContent = v;
        variantEl.hidden = !v;
      }
      var disabled = mainBtn.disabled || mainBtn.hasAttribute('disabled');
      barBtn.disabled = disabled;
      var label = (mainBtn.querySelector('span') || mainBtn).textContent.replace(/\s+/g, ' ').trim();
      if (label) barBtn.querySelector('span').textContent = label;
    }

    function toggle() {
      var show = !mainBtnVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      barBtn.tabIndex = show ? 0 : -1;
      document.body.classList.toggle('wb-satc-on', show);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { mainBtnVisible = e.isIntersecting; });
        toggle();
      }, { threshold: 0 }).observe(mainBtn);
    }

    barBtn.addEventListener('click', function () {
      if (barBtn.disabled) return;
      mainBtn.click();
    });

    // Varianten-, Preis- und Button-Änderungen übernehmen
    var mo = new MutationObserver(function () { window.requestAnimationFrame(sync); });
    mo.observe(mainBtn, { attributes: true, childList: true, subtree: true, characterData: true });
    var priceBox = document.querySelector('#MainContent [id^="price-template"]');
    if (priceBox) mo.observe(priceBox, { childList: true, subtree: true, characterData: true });
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('variant-selects, variant-radios')) {
        setTimeout(sync, 50);
      }
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(sync, 50); });
    }
    sync();
    toggle();
  }

  /* ---------- Lange Kategorie-Beschreibungen einklappen ---------- */
  function initCollapsibleDescriptions() {
    var de = (document.documentElement.lang || 'de').toLowerCase().indexOf('de') === 0;
    var txtMore = de ? 'Weiterlesen' : 'Read more';
    var txtLess = de ? 'Weniger anzeigen' : 'Show less';
    var els = document.querySelectorAll('.collection-hero__description');
    els.forEach(function (el, i) {
      if (el.dataset.wbCollapsible) return;
      if (el.scrollHeight <= 170) return;
      el.dataset.wbCollapsible = '1';
      if (!el.id) el.id = 'wb-coll-desc-' + i;
      el.classList.add('wb-collapsible');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wb-readmore';
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', el.id);
      btn.innerHTML = '<span>' + txtMore + '</span><svg aria-hidden="true" focusable="false" viewBox="0 0 10 6"><path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z"/></svg>';
      el.insertAdjacentElement('afterend', btn);
      btn.addEventListener('click', function () {
        var open = el.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.querySelector('span').textContent = open ? txtLess : txtMore;
        if (!open) el.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      });
    });
  }

  function init() {
    try { initStickyAtc(); } catch (e) { console.warn('[webstra] sticky ATC', e); }
    try { initCollapsibleDescriptions(); } catch (e) { console.warn('[webstra] collapsible', e); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
